import { Link, useNavigate } from "react-router-dom";
import { axiosWithoutAuth } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";
import { base64Encode, isValidArray } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { Fragment, useEffect, useState } from "react";
import { WesCatalogueCard } from "./wesCatalogueCardView";

export const CatalogueContainer = ({ viewBox, UserResponse }) => {
  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;

  return (
    <Fragment>
      <div className={`${viewBox === "grid" ? "col-md-8 col-lg-9" : "col-md-8"}`}>
        <div className="catalogueList-title WesCatlog-filters">
          <h4 className="mb-0">WES Catalogues</h4>
        </div>
        <div className="row">
          {isValidArray(UserResponse) &&
            UserResponse.map((item, index) => (
              <WesCatalogueCard key={`CatalogueItem_${index}`} index={index} viewBox={viewBox} UserResponse={item} />
            ))}
        </div>
      </div>
    </Fragment>
  );
};
